import * as types from './mutation-types'
import shopsApi from '../../endpoints/shop'
import store from '@/store'
import moment from 'moment'

export const actions = {

    async getShops({ commit, dispatch, getters, rootGetters }, payload) {

        commit(types.SHOPS_LOADING)

        const { data } = await shopsApi.getShops(payload)

        if (data.hcode === "ko") {
            commit(types.SHOPS_ERROR, { error: error, data: null })
            return
        }

        commit(types.SHOPS_COMPLETE, data.data.data)

        return data
    },

    async searchShops({ commit, dispatch, getters, rootGetters }, payload) {

        commit(types.SHOPS_SEARCHED_LOADING)

        const { data } = await shopsApi.searchShops(payload)

        if (data.hcode === "ko") {
            commit(types.SHOPS_SEARCHED_ERROR, { error: error, data: null })
            return
        }

        commit(types.SHOPS_SEARCHED_COMPLETE, data.data.data)

        return data
    },    

    async shopDetail({ commit, dispatch, getters, rootGetters }, payload) {

        commit(types.SHOP_DETAIL_LOADING)
        
        const { data } = await shopsApi.shopDetail({
            shop_id: payload
        })

        if (data.hcode === "ko") {
            commit(types.SHOP_DETAIL_ERROR, { error: error, data: null })
            return
        }

        //clean cart when shop changed
        if(getters.current && getters.current.oid !== payload) {
            //store.dispatch('cart/cartClean')
        }
        
        await commit(types.SHOP_DETAIL_COMPLETE, data.data.data)

        return data
    },
    
    async updateProducts({ commit, dispatch, getters, rootGetters }, oid) {
        commit(types.PRODUCT_UPDATE, oid)
    },

    async updateServices({ commit, dispatch, getters, rootGetters }, oid) {
        commit(types.SERVICES_UPDATE, oid)
    },
    
    async getServices({ commit, dispatch, getters, rootGetters }) {

        commit(types.GET_SERVICES_LOADING)        

        let current = store.getters['shops/current']
        let reservationDate = store.getters['global/reservationDateForServer']

        const { data } = await shopsApi.getServices({ soid: current.oid, date: reservationDate })

        if (data.hcode === "ko") {
            commit(types.GET_SERVICES_ERROR, { error: error, data: null })
            return
        }

        commit(types.GET_SERVICES_COMPLETE, data.data.data)

        return data
    },     

}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/shops/actions.js
// module id = null
// module chunks = 